import axios from 'axios';
import useAuthStore from '../store/useAuthStore';

export default (isAuth = true) =>
  axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 1000 * 5,
    headers: isAuth ? { Authorization: `Bearer ${useAuthStore.getState().token}` } : undefined,
  });
